﻿'use strict'

import config from '../../common/config';
var other = require('../helper/other');

export default (function () {
    var API = {
        postFeed : function(app) {
            var src = app.entities.collections.image.where( { name : 'QRCodeImageUrl'} );
            var picture = '';

            if (src.length > 0) {
                picture = src[0].attributes.cdn;
            }
            /* test */
            
            //FB.ui({
            //    method: 'feed',
            //    name: "NAME",
            //    caption: 'events4us.net',
            //    description: 'desc desc desc desc desc desc desc desc desc desc desc desc desc desc desc',
            //    link: 'www.google.dk',
            //    picture: 'http://www.eahsn.org/files/large/d6966e703f9deb4a279ea5113f55b1e8.png'
            //}, function (response) { });
            

            var link = window.luxaforboard.event.fb.link;
            
            /*if (!config.online()) {
                var link = 'http://events4us.net';
            }*/

            //FB.ui({
            //    method: 'feed',
            //    name: window.luxaforboard.event.fb.name,
            //    caption: window.luxaforboard.event.fb.caption,
            //    description: window.luxaforboard.event.fb.description,
            //    link: link,
            //    picture: picture
            //}, function (response) {  
            //    alert(response);
            //});

            var fb_name = app.entities.collections.text.where( { name : 'fb_name'} );
            var fb_description = app.entities.collections.text.where( { name : 'fb_description'} );
            

            FB.ui({
                method: 'share_open_graph',
                action_type: 'og.shares',
                action_properties: JSON.stringify({
                    object: {
                        'og:url': link,
                        'og:title': fb_name[0].attributes.value,
                        'og:type': 'object',
                        'og:description': fb_description[0].attributes.value,
                        'og:image': picture,
                        'og:image:width': '200',
                        'og:image:height': '200'
                    }
                })
            }, function (response) {
                // Debug response (optional)
                console.log(response);
            });
        }
    };

    return API;
})();



